export default "/images/vendor/flag-icon-css/flags/4x3/sb.svg?2c405bb603253b6e2040a62b6b417b90";